var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"item-inner"},[_c('p',{staticClass:"ellipsis",attrs:{"title":_vm.source.id+'、'+_vm.source.name}},[_vm._v(" "+_vm._s(_vm.source.id)+"、"+_vm._s(_vm.source.name)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }